import layout from '@/layout'

export default {
  path: '/log',
  component: layout,
  redirect: '/log/plat/manage',
  name: 'platLog',
  meta: {
    title: '日志管理',
    icon: 'log'
  },
  children: [
    {
      path: '/log/plat/manage',
      component: () => import('@/views/log-manage/plat-log/index'),
      meta: {
        title: '平台授权日志',
        icon: 'api-app'
      }
    },
    {
      path: '/log/plat/:id',
      component: () => import('@/views/log-manage/plat-log/info'),
      meta: {
        title: '平台授权日志详情'
      }
    }
  ]
}
